export type Environment = "development" | "staging" | "loadtest" | "production";
const DEFAULT_ENVIRONMENT: Environment = "staging";

export function getEnvironment(): Environment {
	if (window.location.hostname === "localhost") {
		return "development";
	}

	if (window.location.hostname === "signers.crossmint.com") {
		return "production";
	}

	if (window.location.hostname === "loadtest.signers.crossmint.com") {
		return "loadtest";
	}

	return DEFAULT_ENVIRONMENT;
}

export function isDevelopment(): boolean {
	return getEnvironment() === "development";
}
